/* eslint-disable import/no-anonymous-default-export */
import environment from '../environments/Environment';
import HttpService from './HttpService';

export default {
    getCookieCategoryList(params) {
        return HttpService.get(environment.API_COOKIE_CATEGORY, {
            params,
        });
    },
    getCategoryDetail(params) {
        return HttpService.get(environment.API_COOKIE_CATEGORY + '/detail', {
            params,
        });
    },
    createCookieCategory(payload) {
        return HttpService.post(environment.API_COOKIE_CATEGORY, payload);
    },
    updateCookieCategory(payload) {
        return HttpService.put(environment.API_COOKIE_CATEGORY, payload);
    },
    deleteCookieCategory(id) {
        return HttpService.delete(environment.API_COOKIE_CATEGORY + `/${id}`);
    },
    createCookie(payload) {
        return HttpService.post(environment.API_COOKIE, payload);
    },
    updateCookie(payload) {
        return HttpService.put(environment.API_COOKIE, payload);
    },
    deleteCookie(id) {
        return HttpService.delete(environment.API_COOKIE + `/${id}`);
    },
    HiddenCookie(payload) {
        return HttpService.patch(environment.API_COOKIE_CATEGORY, payload);
    },
};
